import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from './types'
import { LANG } from './lang'
import { API } from './api'
import { CONTENT } from './content'
import { COOKIES } from './cookies'
import config from 'config'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {
    version: config.app.version,
    name: config.app.name
  },
  modules: {
    LANG,
    API,
    CONTENT,
    COOKIES
  }
}

export default new Vuex.Store<RootState>(store)
